import React, { useId } from 'react';

const Icon = ({ size = '70', fill = '#FFEFBC', ...other }) => {
    const id = useId();
    const gradientA = `signUpIcon-gradient-a-${id}`;
    const gradientB = `signUpIcon-gradient-b-${id}`;
    const gradientC = `signUpIcon-gradient-c-${id}`;

    return (
        <svg width={size} height={size} viewBox="0 0 70 70" fill="none" {...other}>
            <path d="M61.25 30.625H46.667" stroke="#EAC280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />

            <path d="M53.958 23.333v14.583" stroke={`url(#${gradientA})`} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />

            <path fillRule="evenodd" clipRule="evenodd" d="M49.583 58.333C49.583 45.447 40.443 35 29.167 35S8.75 45.447 8.75 58.333" fill={fill} />

            <path
                d="M49.583 58.333v1a1 1 0 0 0 1-1h-1Zm-40.833 0h-1a1 1 0 0 0 1 1v-1Zm40.833 0h1C50.583 45.024 41.116 34 29.167 34v2c10.602 0 19.416 9.87 19.416 22.333h1ZM29.167 35v-1C17.217 34 7.75 45.024 7.75 58.333h2C9.75 45.87 18.564 36 29.167 36v-1Zm20.416 23.333v-1H8.75v2h40.833v-1Z"
                fill={`url(#${gradientB})`}
            />

            <path
                d="M29.167 35c6.443 0 11.666-5.223 11.666-11.666 0-6.444-5.223-11.667-11.666-11.667-6.444 0-11.667 5.223-11.667 11.667C17.5 29.777 22.723 35 29.167 35Z"
                fill={fill}
                stroke={`url(#${gradientC})`}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />

            <defs>
                <linearGradient id={gradientA} x1="54.458" y1="23.333" x2="54.458" y2="37.916" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F7D391" />

                    <stop offset="1" stopColor="#DAAB69" />
                </linearGradient>
                <linearGradient id={gradientB} x1="29.167" y1="35" x2="29.167" y2="58.333" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E8BF7D" />

                    <stop offset="1" stopColor="#D19F5D" />
                </linearGradient>
                <linearGradient id={gradientC} x1="29.167" y1="11.667" x2="29.167" y2="35" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F9D694" />

                    <stop offset="1" stopColor="#E7BE7C" />
                </linearGradient>
            </defs>
        </svg>
    );
};
export default React.memo(Icon);
